// VIN Decoder - Eurohaus Supply
// Uses free NHTSA vPIC API to decode VINs
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    var vinInput = document.getElementById('vin-input');
    var vinBtn = document.getElementById('vin-search-btn');
    var vinResult = document.getElementById('vin-result');
    var vinLoading = document.getElementById('vin-loading');
    var vinError = document.getElementById('vin-error');

    if (!vinInput || !vinBtn) return;

    // Handle button click
    vinBtn.addEventListener('click', function(e) {
      e.preventDefault();
      handleVinSearch();
    });

    // Handle Enter key
    vinInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleVinSearch();
      }
    });

    // Auto-uppercase input
    vinInput.addEventListener('input', function() {
      this.value = this.value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '');
    });

    function handleVinSearch() {
      var vin = vinInput.value.trim().toUpperCase();
      
      // Validate
      if (!vin) {
        showError('Please enter a VIN number.');
        return;
      }
      if (vin.length !== 17) {
        showError('VIN must be exactly 17 characters. You entered ' + vin.length + '.');
        return;
      }
      if (/[IOQ]/g.test(vin)) {
        showError('VIN cannot contain letters I, O, or Q.');
        return;
      }

      hideError();
      showLoading(true);
      hideResult();
      decodeVin(vin);
    }

    function decodeVin(vin) {
      var url = 'https://vpic.nhtsa.dot.gov/api/vehicles/decodevinvalues/' + vin + '?format=json';
      
      fetch(url)
        .then(function(response) { return response.json(); })
        .then(function(data) {
          showLoading(false);
          if (data.Results && data.Results.length > 0) {
            var vehicle = data.Results[0];
            
            if (vehicle.ErrorCode && vehicle.ErrorCode !== '0' && !vehicle.Make) {
              showError('Could not decode this VIN. Please check and try again.');
              return;
            }
            
            displayResult(vehicle, vin);
          } else {
            showError('No results found for this VIN.');
          }
        })
        .catch(function(err) {
          showLoading(false);
          showError('Network error. Please try again.');
          console.error('VIN decode error:', err);
        });
    }

    function displayResult(v, vin) {
      var year = v.ModelYear || 'Unknown';
      var make = v.Make || 'Unknown';
      var model = v.Model || 'Unknown';
      var trim = v.Trim || '';
      var engine = v.DisplacementL ? v.DisplacementL + 'L' : '';
      var cylinders = v.EngineCylinders ? v.EngineCylinders + '-cyl' : '';
      var fuel = v.FuelTypePrimary || '';
      var drive = v.DriveType || '';
      var bodyClass = v.BodyClass || '';
      var plantCountry = v.PlantCountry || '';
      
      var engineInfo = [engine, cylinders, fuel].filter(Boolean).join(' / ');
      var vehicleName = year + ' ' + make + ' ' + model + (trim ? ' ' + trim : '');

      // Build search query for parts
      var searchQuery = encodeURIComponent(make + ' ' + model);
      var makeSlug = make.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      
      // Map make to collection
      var makeCollections = {
        'audi': 'audi-parts',
        'bmw': 'bmw-parts',
        'mercedes-benz': 'mercedes-benz-parts',
        'volkswagen': 'volkswagen-parts',
        'porsche': 'porsche-parts',
        'mini': 'mini-parts',
        'volvo': 'volvo-parts'
      };
      var collectionHandle = makeCollections[makeSlug] || null;

      var html = '<div class="vin-result-card">';
      html += '<div class="vin-result-header">';
      html += '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00cc44" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';
      html += '<h3>Vehicle Identified</h3>';
      html += '</div>';
      html += '<div class="vin-vehicle-name">' + vehicleName + '</div>';
      html += '<div class="vin-details-grid">';
      
      if (engineInfo) html += '<div class="vin-detail"><span class="vin-label">Engine</span><span class="vin-value">' + engineInfo + '</span></div>';
      if (drive) html += '<div class="vin-detail"><span class="vin-label">Drivetrain</span><span class="vin-value">' + drive + '</span></div>';
      if (bodyClass) html += '<div class="vin-detail"><span class="vin-label">Body</span><span class="vin-value">' + bodyClass + '</span></div>';
      if (plantCountry) html += '<div class="vin-detail"><span class="vin-label">Made In</span><span class="vin-value">' + plantCountry + '</span></div>';
      html += '<div class="vin-detail"><span class="vin-label">VIN</span><span class="vin-value" style="font-family:monospace;font-size:12px">' + vin + '</span></div>';
      
      html += '</div>';
      html += '<div class="vin-result-actions">';
      html += '<a href="/search?q=' + searchQuery + '" class="vin-btn-primary">Search Parts for ' + make + ' ' + model + '</a>';
      if (collectionHandle) {
        html += '<a href="/collections/' + collectionHandle + '" class="vin-btn-secondary">Browse All ' + make + ' Parts</a>';
      }
      html += '</div>';
      html += '</div>';
      
      vinResult.innerHTML = html;
      vinResult.style.display = 'block';
      
      // Scroll result into view
      vinResult.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function showLoading(show) {
      if (vinLoading) vinLoading.style.display = show ? 'flex' : 'none';
      if (vinBtn) vinBtn.disabled = show;
    }

    function showError(msg) {
      if (vinError) {
        vinError.textContent = msg;
        vinError.style.display = 'block';
      }
    }

    function hideError() {
      if (vinError) vinError.style.display = 'none';
    }

    function hideResult() {
      if (vinResult) vinResult.style.display = 'none';
    }
  });
})();